import {
  Box,
  Checkbox,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import {
  CustomFieldInstance,
  ExtendedOptions,
} from "lib/features/checkout/checkoutService";
import React from "react";
import { additionalInformationFareharborStyles as styles } from "styles/Checkout/additionalInformationFareharbor.styles";
import { ReactComponent as CustomDropDownIcon } from "../../../assets/icons/black_down_arrow.svg";

interface AdditionalInformationFareharborProps {
  customFields: CustomFieldInstance[];
  setCustomFields: React.Dispatch<React.SetStateAction<CustomFieldInstance[]>>;
  setTotalCost: any;
}

const AdditionalInformationFareharbor: React.FC<
  AdditionalInformationFareharborProps
> = ({ customFields, setCustomFields, setTotalCost }) => {
  const theme = useTheme();
  const checkYesNo = (value: string | undefined) => {
    if (value === "yes") {
      return true;
    } else {
      return false;
    }
  };
  const isRequiredPresent =
    customFields.filter((f) => f.custom_field.is_required === true).length > 0;
  const [requiredMet, setRequiredMet] = React.useState(!isRequiredPresent);
  //Value = PK of Choice, i = index of Field from customFields.
  const handleFieldChange = (value: string | number, i: number) => {
    // let currentFields = customFields;

    if (customFields[i].custom_field.type === "extended-option") {
      if (customFields[i].custom_field.is_required === true) {
        setRequiredMet(true);
      }
      const selectedOption = customFields[i].custom_field.extended_options.find(
        (x: any) => x.pk === Number(value)
      );

      // Previous Extended Option Selected....
      customFields[i].custom_field.extended_options.forEach((eo) => {
        if (eo.pk === Number(value)) {
          eo.is_selected = true;
          customFields[i].value_given = eo.pk;
        } else {
          eo.is_selected = false;
        }
      });

      const newTotal = selectedOption ? selectedOption.total : 0;
      setTotalCost(newTotal / 100, i);
    } else if (customFields[i].custom_field.type === "yes-no") {
      // Update field value

      customFields[i].value_given = value.toString();
      //Setup $ Change if there is one.....
      const isChecked = value === "yes";
      const totalChange = isChecked
        ? customFields[i].custom_field.total
        : -customFields[i].custom_field.total;
      setTotalCost((prevTotal: number) => prevTotal + totalChange / 100, i);
    } else {
      customFields[i].custom_field.value_given = value.toString();
    }

    setCustomFields(customFields);
  };
  const calculateValuesForDropDown = (min: number, max: number) => {
    const values = [];
    for (let i = min; i <= max; i++) {
      values.push(i);
    }
    return values;
  };
  return (
    <>
      {customFields.map((customField: CustomFieldInstance, i: number) => {
        // Exclude "short" and "long" fields, and "extended-option" fields where all options have a total of 0
        if (
          customField.custom_field.type === "short" ||
          customField.custom_field.type === "long" ||
          (customField.custom_field.type === "extended-option" &&
            !customField.custom_field.extended_options.some(
              (option: ExtendedOptions) => option.total > 0
            )) ||
          Number(customField.custom_field.percentage) < 0.0 ||
          Number(customField.custom_field.total) < 0.0
        ) {
          return null;
        }
        const isRequired = customField.custom_field.is_required;
        return (
          <Box key={customField.custom_field.pk} sx={styles.fieldContainer}>
            {!["yes-no", "extended-option"].includes(
              customField.custom_field.type
            ) && (
                <>
                  <Box sx={styles.nonOptionHeader()}>
                    <Typography sx={styles.fieldTitle(theme)}>
                      {customField.custom_field.title}
                    </Typography>
                    {isRequired && (
                      <Typography
                        component="span"
                        sx={styles.requiredAsterisk}
                      >
                        *
                      </Typography>
                    )}
                  </Box>
                </>
              )}

            {customField.custom_field.type === "extended-option" && (
              <>
                <Box sx={styles.extendedOptionHeader}>
                  <Typography sx={styles.extendedOptionTitle(theme)}>
                    {customField.custom_field.title}
                  </Typography>
                  {isRequired && (
                    <Typography
                      component="span"
                      sx={styles.requiredAsterisk}
                    >
                      *
                    </Typography>
                  )}
                </Box>

                <Select
                  fullWidth
                  required={isRequired}
                  defaultValue={""}
                  IconComponent={() => <CustomDropDownIcon style={styles.customDropDownIconStyle} />}
                  onChange={(event) => handleFieldChange(event.target.value, i)}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxWidth: 300,
                      },
                    },
                  }}
                  sx={styles.extendedOptionSelect}
                >
                  {customField.custom_field.extended_options.map(
                    (option: any) => (
                      <MenuItem
                        key={option.pk}
                        value={option.pk}
                        sx={styles.menuItem}
                      >
                        <Box sx={styles.optionContainer}>
                          {option.name}

                          {option?.total > 0 && (
                            <Typography sx={styles.optionPriceText}>
                              {`$ `}
                              {option.total / 100}
                            </Typography>
                          )}
                        </Box>
                      </MenuItem>
                    )
                  )}
                </Select>
                {customField.custom_field.description && (
                  <Typography sx={styles.optionDescription}>
                    {customField.custom_field.description}
                  </Typography>
                )}
              </>
            )}

            {customField.custom_field.type === "short" && (
              <>
                <TextField
                  fullWidth
                  required={isRequired}
                  onChange={(event) => handleFieldChange(event.target.value, i)}
                  sx={styles.textFieldStyle}
                />
              </>
            )}

            {customField.custom_field.type === "long" && (
              <TextField
                fullWidth
                multiline
                required={isRequired}
                rows={4}
                onChange={(event) => handleFieldChange(event.target.value, i)}
                sx={styles.textFieldStyle}
              />
            )}

            {customField.custom_field.type === "count" && (
              <Box sx={styles.countContainer}>
                <Select
                  fullWidth
                  required={isRequired}
                  defaultValue={customField.custom_field.value_given || "0"}
                  onChange={(event) => handleFieldChange(event.target.value, i)}
                  sx={styles.countSelect}
                >
                  {calculateValuesForDropDown(
                    customField.custom_field.count_min,
                    customField.custom_field.count_max
                  ).map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            )}

            {customField.custom_field.type === "yes-no" && (
              <>
                <Box sx={styles.yesNoHeader}>
                  <Typography sx={styles.yesNoHeaderText(theme)}></Typography>
                  {isRequired && (
                    <Typography
                      component="span"
                      sx={styles.requiredAsterisk}
                    >
                      *
                    </Typography>
                  )}
                </Box>
                <Box sx={styles.yesNoContainer}>
                  <Checkbox
                    // checked={checkYesNo(
                    //   customFields[i].value_given
                    //     ? customFields[i].value_given
                    //     : "no"
                    // )}
                    required={isRequired}
                    onChange={(event) =>
                      handleFieldChange(event.target.checked ? "yes" : "no", i)
                    }
                    sx={styles.checkboxStyle}
                  />

                  <Box sx={styles.checkboxTextContainer}>
                    <Box sx={styles.checkboxHeaderContainer}>
                      <Typography sx={styles.checkboxTitle(theme)}>
                        {customField.custom_field.title}
                      </Typography>
                      {customField.custom_field.total > 0 && (
                        <>
                          <InputLabel
                            sx={styles.checkBoxPrice}
                          >
                            $ {customField.custom_field.total / 100}
                          </InputLabel>
                        </>
                      )}
                    </Box>

                    {customField.custom_field.description && (
                      <Typography variant="body2"
                        sx={styles.checkboxDescription}>
                        {customField.custom_field.description}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </>
            )}
          </Box>
        );
      })}
    </>
  );
};

export default AdditionalInformationFareharbor;
